import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FutureReadyAustralia from "./sections/FutureReadyAustralia";
import OurStoryMission from "./sections/OurStoryMission";
import EmpoweringThroughEducation from "./sections/EmpoweringThroughEducation";
import SpotlightTechnobudz from "./sections/SpotlightTechnobudz";
import WhoWeSupport from "./sections/WhoWeSupport";
import TheFutureReadyDifference from "./sections/TheFutureReadyDifference";
import JoinOurMovement from "./sections/JoinOurMovement";
import Whyfuturereadyskills from "./sections/Whyfuturereadyskills";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FutureReadyAustralia />
      <OurStoryMission />
      <TheFutureReadyDifference />
      <EmpoweringThroughEducation />
      <Whyfuturereadyskills />
      <SpotlightTechnobudz />
      <WhoWeSupport />
      <JoinOurMovement />
      <Footer />
    </div>;
}